<template>
  <SfModalPortal
    modal-id="publish-check-list-confirmation-modal"
    :size="'xs'"
    @opened="handleOpened"
  >
    <template #title>
      {{ I18n.t('check_lists.publish_confirmation_modal.title') }}
    </template>

    <template #body>
      <div>
        {{ I18n.t('check_lists.publish_confirmation_modal.body') }}
      </div>

      <div v-if="newChecksCount > 0" class="tw-mt-4 tw-text-sf-gray-light">
        {{ I18n.t('check_lists.publish_confirmation_modal.body_new_checks') }}
      </div>
    </template>

    <template #footer>
      <SfButtonDs @click="handleCancel">
        {{ I18n.t('check_lists.publish_confirmation_modal.cancel') }}
      </SfButtonDs>
      <SfButtonDs variant="primary" @click="handleSuccess">
        {{ I18n.t('check_lists.publish_confirmation_modal.publish_button') }}
      </SfButtonDs>
    </template>
  </SfModalPortal>
</template>

<script lang="ts" setup>
import { SfModalPortal } from '@app/shared/vue/components/sf-modal'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import type { ModalPortalPayloadMap } from '@app/types'

const I18n = window.I18n

import { ref } from 'vue'

const newChecksCount = ref(0)

const handleOpened = (
  payload: ModalPortalPayloadMap['publish-check-list-confirmation-modal']
) => {
  newChecksCount.value = payload.newChecksCount
}

const handleCancel = () => {
  window.modalCitizen.closeModalPortal()
}

const handleSuccess = () => {
  window.modalCitizen.closeModalPortal()
  window.eventHub.$emit('publish-check-list-confirmed')
}
</script>
